import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { CentralizedSingleCabinLuggagePolicySection1 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection1";
import { CentralizedSingleCabinLuggagePolicySection2 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection2";

export const CentralizedSingleCabinLuggagePolicy = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const travellersInfoCard = [
    {
      label: "Page Content",
      key: "centralizedSingleCabinLuggagePolicyPageContent",
      children: <CentralizedSingleCabinLuggagePolicySection1 />,
    },
    {
      label: "Page Image",
      key: "singleCabinLuggagePolicyPageImage",
      children: <CentralizedSingleCabinLuggagePolicySection2 />,
    },
  ];

  return (
    // <ContentWrapper>
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
